import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const formatPhoneNumber = (rawPhone) => {
  if (!rawPhone) return null;

  try {
    const phoneNumber = parsePhoneNumberFromString(rawPhone);

    if (!phoneNumber || !phoneNumber.isValid()) {
      console.warn('Numéro invalide :', rawPhone);
      return null;
    }

    return {
      number: phoneNumber.nationalNumber, // ex: '0163847696'
      country: phoneNumber.country,       // ex: 'BJ'
    };
  } catch (error) {
    console.error('Erreur de parsing du numéro :', error);
    return null;
  }
};
